const log = (...args) => window.SAS_DEBUG && console.log("[SAS]", ...args);

document.addEventListener("DOMContentLoaded", () => {
    const dataScript = document.getElementById("sas-selling-options-type-data");
    if (!dataScript) {
        log("sas-selling-options-type-data script tag not found — snippet not rendered on this page");
        return;
    }

    let data = null;

    try {
        data = JSON.parse(dataScript.textContent);
        log("Data loaded:", data);
    } catch (e) {
        log("Error parsing selling options data:", e);
        return;
    }

    function normalize(type) {
        if (!type) return null;
        type = type.toLowerCase().trim();
        if (type === "call_for_price" || type.includes("call")) return "call_for_price";
        if (type === "custom_button" || type.includes("custom")) return "custom_button";
        if (type === "inquire_button" || type.includes("inquire")) return "inquire_button";
        return null;
    }

    const globalType = normalize(data.globalType);
    log("Global type:", globalType);

    const buttons = {
        call_for_price: document.querySelector(".call_btn"),
        custom_button:  document.querySelector(".custom_btn"),
        inquire_button: document.querySelector(".btn-inquired")
    };

    log("Buttons found:", {
        call_for_price: !!buttons.call_for_price,
        custom_button:  !!buttons.custom_button,
        inquire_button: !!buttons.inquire_button
    });

    function hideAll() {
        Object.values(buttons).forEach(btn => {
            if (btn) btn.style.display = "none";
        });
    }

    function updateLabel(btn, variantData, type) {
        const label = btn.querySelector(".selling-options-label");
        if (!label) return;

        const variantTitle = variantData?.selling_options_title;
        if (variantTitle) {
            log(`Label updated from variant metafield: "${variantTitle}"`);
            label.textContent = variantTitle;
            return;
        }

        const typeText = data.typeTexts?.[type];
        if (typeText) {
            log(`Label updated from settings: "${typeText}"`);
            label.textContent = typeText;
        }
    }

    function show(type, variantData) {
        hideAll();
        const btn = buttons[type];
        if (!btn) {
            log(`show() — no button found for type "${type}"`);
            return;
        }
        updateLabel(btn, variantData, type);
        log(`Showing button: "${type}"`);
        btn.style.display = "block";
    }

    function getTypeForVariantId(variantId) {
        const variant = data.variants.find(v => v.id === variantId);
        const type = normalize(variant?.selling_options) || globalType;
        log(`Variant ${variantId} → selling_options: "${variant?.selling_options}" → resolved type: "${type}"`);
        return type;
    }

    function getVariantDataById(variantId) {
        return data.variants.find(v => v.id === variantId) || null;
    }

    function applyInitialType() {
        const variantInput = document.querySelector(`form[id*="${data.productId}"] input[name="id"], input[name="id"]`);
        const variantId = variantInput ? parseInt(variantInput.value) : data.variants[0]?.id;
        log("Initial variant ID:", variantId);
        if (!variantId) {
            log("No variant ID found on load");
            return;
        }
        const type = getTypeForVariantId(variantId);
        show(type, getVariantDataById(variantId));
    }

    applyInitialType();

    document.addEventListener("variant:changed", (e) => {
        const variantId = e.detail?.variant?.id;
        log("variant:changed event — variant ID:", variantId);
        if (!variantId) return;
        const type = getTypeForVariantId(variantId);
        show(type, getVariantDataById(variantId));
    });
});
